import{getDefaultExportFromCjs as r}from"./_commonjsHelpers.js";import{__require as o}from"../node_modules/.pnpm/color-name@1.1.4/node_modules/color-name/index.js";var e=o();const m=r(e);export{m as default};
